import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExternalLink, Github } from 'lucide-react';
import { getFileUrl } from '../helpers/fileHelpers';
import ModelDescription from "./ModelDescription";

const Projects = ({ isVisible, projects }) => {
  const navigate = useNavigate();

  return (
  <section id="projects" className="py-20 px-6">
    <div className="container mx-auto max-w-6xl">
      <div className={`transition-all duration-1000 ${isVisible.projects ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h2 className="text-4xl font-bold mb-12 text-center bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Projects
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={project.title}
              className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl overflow-hidden hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-cyan-500/20"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="h-48 bg-gradient-to-r from-cyan-500 to-blue-500 relative overflow-hidden">
                <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                  <img
                    src={getFileUrl(project?.image)}
                    alt={project.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/placeholder-project.jpg';
                    }}
                  />
                </div>
              </div>
              <div className="p-6">
                <h3 
                  className="text-xl font-bold mb-3 hover:text-cyan-400 cursor-pointer transition-colors"
                  onClick={() => navigate(`/projects/${project._id}`)}
                >
                  {project.title}
                </h3>
                <ModelDescription description={
                    project.description.split(" ").slice(0, 20).join(" ") +
                    (project.description.split(" ").length > 20 ? "..." : "")
                  } 
                />
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="px-3 py-1 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-sm rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="flex space-x-4">
                  <a
                    href={project.liveDemo} target="_blank" rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-cyan-400 hover:text-cyan-300 transition-colors"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Demo</span>
                  </a>
                  <a
                    href={project.sourceCode} target="_blank" rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-gray-400 hover:text-gray-300 transition-colors"
                  >
                    <Github className="w-4 h-4" />
                    <span>Code</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};

export default Projects;
